import { useQuery } from "@apollo/client";
import { ItemTypeEnum, type ScanPostCatalog } from "@jasper/client-models";
import {
  FindItemMaterialsByItemTypeDocument,
  GetScanPostCatalogDocument,
} from "../../gql/generated/graphql";

const EMPTY_CATALOG: ScanPostCatalog = { types: [], scanPosts: [] };

export const useScanPostCatalog = () => {
  const { data, loading, error } = useQuery(GetScanPostCatalogDocument);

  const scanPostCatalog: ScanPostCatalog = data
    ? {
        types: data.getScanPostCatalog.types.map(
          ({ value, label, subLabel, description }) => ({
            value,
            label,
            subLabel: subLabel ?? undefined,
            description: description ?? undefined,
          })
        ),
        scanPosts: data.getScanPostCatalog.scanPosts.map(
          ({ type, id, label }) => ({
            type,
            value: id,
            label,
          })
        ),
      }
    : EMPTY_CATALOG;

  return { scanPostCatalog, isLoading: loading, error };
};

export const useInlayCoreChoices = () => {
  const {
    data,
    loading: isLoadingMaterials,
    error: materialsError,
  } = useQuery(FindItemMaterialsByItemTypeDocument, {
    variables: { itemType: ItemTypeEnum.inlayCore },
  });
  const {
    scanPostCatalog,
    isLoading: isLoadingScanPosts,
    error: scanPostsError,
  } = useScanPostCatalog();

  const itemMaterials = (data?.findItemMaterialsByItemType ?? []).map(
    ({ id, name }) => ({ value: id, label: name })
  );

  return {
    isLoading: isLoadingMaterials || isLoadingScanPosts,
    error: materialsError ?? scanPostsError,
    itemMaterials,
    scanPostCatalog,
  };
};
